import './styles.scss'
import React from 'react'
import Nixi1Spinner from 'components/Nixi1Spinner'

const Button = (props) => {
  const {
    icon, primary, clearPrimary, secondary, tertiary, light, container, containerPrimary, bordered,
    remove, onClick, isSubmitting, value, className, disabled, small, children, clearGray
  } = props

  return (
    <div
      className={`
        new-custom-button
        ${icon ? 'icon-style-button' : ''}
        ${primary ? 'primary-button' : ''}
        ${clearPrimary ? 'clear-primary-button' : ''}
        ${secondary ? 'secondary-button' : ''}
        ${tertiary ? 'tertiary-button' : ''}
        ${light ? 'light-button' : ''}
        ${container ? 'container-button' : ''}
        ${containerPrimary ? 'container-primary-button' : ''}
        ${bordered ? 'bordered-button' : ''}
        ${remove ? 'remove-button' : ''}
        ${disabled ? 'disabled-button' : ''}
        ${className ? className : ''}
        ${small ? 'small' : ''}
        ${clearGray ? 'clear-gray-button' : ''}
      `}
      onClick={() => (!disabled && !isSubmitting) ? onClick() : null}
    >
      {icon ? icon : null}
      {isSubmitting ? (
        <Nixi1Spinner width='1.5rem' height='1.5rem' />
      ) : children ? (
        <p>{children}</p>
      ) : (
        <p dangerouslySetInnerHTML={{ __html: value }} />
      )}
    </div>
  )
}

export default Button
